import { render } from "./HFO_BI_002.vue?vue&type=template&id=2c86a06b&scoped=true"
import script from "./HFO_BI_002.vue?vue&type=script&lang=js"
export * from "./HFO_BI_002.vue?vue&type=script&lang=js"

import "./HFO_BI_002.vue?vue&type=style&index=0&id=2c86a06b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c86a06b"]])

export default __exports__